module.exports = __webpack_public_path__ + "img/c02_unitwarelephantchampion_Normal_ua.158d275f.webp";